module.exports = __webpack_public_path__ + "img/missing-img.c8cb53ff.svg";